import { PriceScopeType } from '../constants/price-scope-type.js';
// Values match 09_demo_pricing.sql and the revision's fix for the never-implemented
// "narrowest-wins" doc comment on PriceScopeType: priority DESC already produces narrowest-wins
// for every ordinary rule once the default *is* the scope band, so the resolver's primary sort
// key does not need a separate specificity key.
export const PRICE_RULE_PRIORITY_BY_SCOPE = {
    [PriceScopeType.CATEGORY_DEFAULT]: 0,
    [PriceScopeType.MARKET]: 10,
    [PriceScopeType.PRODUCT]: 20,
    [PriceScopeType.ACCOUNT]: 30,
    [PriceScopeType.ACCOUNT_PRODUCT]: 40,
};
// "Lock this price" overrides every scope's default band, including ACCOUNT_PRODUCT's.
export const LOCKED_PRICE_PRIORITY = 1000;
//# sourceMappingURL=price-rule-priority.js.map